export function handleApiResponse(response, options = {}) {
  const {
    successMessage = null,
    showSuccessToast = false,
    defaultErrorMessage = 'Notikusi neparedzēta kļūda. Lūdzu mēģiniet vēlreiz.',
    handleWarnings = false,
  } = options;

  if (response?.data?.code === 'ok') {
    if (showSuccessToast && successMessage) {
      return {
        status: {
          code: 'ok',
          messages: [successMessage]
        }
      };
    }

    return null;

  } else if (response?.data?.messages && response?.data?.messages.length > 0) {
    const messages = response.data.messages;

    // If warning handling is enabled and response code is 'warning'
    if (handleWarnings && response.data.code === 'warning') {
      const approvableWarnings = [];

      messages.forEach(message => {
        approvableWarnings.push({
          message: message,
          severity: 'warning'
        });
      });

      return {
        status: {
          code: response.data.code,
          approvableWarnings: approvableWarnings
        }
      };
    } else {
      // Standard handling - return all messages as before
      return {
        status: {
          code: response.data.code,
          messages: messages
        }
      };
    }
  } else {
    return {
      status: {
        code: 'error',
        messages: [defaultErrorMessage]
      }
    };
  }
}

export function handleApiError(error, errorMessage = 'Notikusi neparedzēta kļūda. Lūdzu mēģiniet vēlreiz.') {
  return {
    status: {
      code: 'error',
      messages: [errorMessage]
    }
  };
}

export function handleApiErrors(error, customErrorMessage = 'Notikusi neparedzēta kļūda. Lūdzu mēģiniet vēlreiz.') {
  if (error?.code === 'rate-limit-error') {
    if (typeof window !== 'undefined' && window.$router) {
      window.$router.push(`/rate-limit-exceeded`);
    } else {
      // Fallback if router isn't available
      window.location.href = `/rate-limit-exceeded`;
    }
  }

  if (Array.isArray(error)) {
    return {
      status: {
        code: 'error',
        messages: error
      }
    };
  }

  // If error has the API response structure with messages
  if (error && error.messages && Array.isArray(error.messages)) {
    return {
      status: {
        code: error.code || 'error',
        messages: error.messages
      }
    };
  }

  if (customErrorMessage) {
    return {
      status: {
        code: 'error',
        messages: [customErrorMessage]
      }
    };
  }

  return {
    status: {
      code: 'error',
      messages: ['Notikusi neparedzēta kļūda. Lūdzu mēģiniet vēlreiz.']
    }
  };
}

// Convenience functions for common scenarios
export function handleDataFetch(response, options = {}) {
  return handleApiResponse(response, {
    showSuccessToast: false,
    ...options
  });
}

export function handleDataSave(response, successMessage = 'Izmaiņas saglabātas', options = {}) {
  return handleApiResponse(response, {
    successMessage,
    showSuccessToast: true,
    ...options
  });
}

export function handleDataDelete(response, successMessage = 'Ieraksts dzēsts', options = {}) {
  return handleApiResponse(response, {
    successMessage,
    showSuccessToast: true,
    ...options
  });
}

// New specialized function for operations that might have approvable warnings
export function handleDataSaveWithWarnings(response, successMessage = 'Izmaiņas saglabātas', approvedWarnings = []) {
  return handleApiResponse(response, {
    successMessage,
    showSuccessToast: true,
    handleWarnings: true,
    approvedWarnings
  });
}

export function handleDataCreateWithWarnings(response, successMessage = 'Ieraksts izveidots', approvedWarnings = []) {
  return handleApiResponse(response, {
    successMessage,
    showSuccessToast: true,
    handleWarnings: true,
    approvedWarnings
  });
}

export function handleDataUpdateWithWarnings(response, successMessage = 'Izmaiņas saglabātas', approvedWarnings = []) {
  return handleApiResponse(response, {
    successMessage,
    showSuccessToast: true,
    handleWarnings: true,
    approvedWarnings
  });
}